import {observer} from "mobx-react";
import {IReactiveNewsContentItem, ReactiveContentItem} from "../../../stores/SchoolFeedStore";
import React, {useRef} from "react";
import {getPlatform} from "../../../utils/StringUtilities";
import styles from "./styles/NewsModal.module.scss";
import {UnpublishedInfoBox} from "../../utilities/UnpublishedInfoBox";
import ImageComponent from "../../utilities/ImageComponent";
import {EditButton} from "../../blocks/TerracedGridTheme/EditButton";
import Moment from "moment";
import SocialMarkdown from "../../utilities/SocialMarkdown";
import {ReadMoreButton} from "../SocialItemModal";
import {MeritChatThread} from "../../utilities/MeritChat";
import ClickableLink from "../../utilities/ClickableLink";
import {buildCleverFeedUrl, buildContentItemUrl} from "../../../utils/SchoolBlocksUtilities";
import {JoinDiscussionButton} from "../../schoolfeed/ListItemGroup";
import NewsModalContentHeader from "./NewsModalContentHeader";
import {useStores} from "../../../stores/useStores";

const NewsModalContent = observer((props: {
    index: number,
    itemObj: ReactiveContentItem,
    handleDelete: (contentItem: ContentItem) => void,
    navigationButtons?: React.ReactElement,
    closeFunction?: () => void,
}) => {
    const {userStore, organizationStore} = useStores();
    const imageUrl = props.itemObj.image;
    const attribution = getPlatform(props.itemObj.type);
    const contentRef = useRef<HTMLDivElement>(null);
    const shareUrlPath = buildContentItemUrl(organizationStore.currentOrganization.id, props.itemObj.id);

    return <div ref={contentRef} className={styles.container}>
        {!props.itemObj.published && <UnpublishedInfoBox unpublishedItemType={"News Item"}/>}
        <NewsModalContentHeader index={props.index}
                                closeFunction={props.closeFunction}
                                itemObj={props.itemObj}
                                navigationButtons={props.navigationButtons}
                                shareUrlPath={shareUrlPath}
                                printRef={contentRef}/>
        <article>
            {imageUrl && <ImageComponent
                src={imageUrl}
                key={props.itemObj.id}
                alt={props.itemObj.title || "Social Post Image"}
            />}
            <div className={styles.titleContainer}>
                <h2>{props.itemObj.title}</h2>
                {userStore.isEditor && <EditButton contentItem={props.itemObj as IReactiveNewsContentItem}
                                                   handleDelete={props.handleDelete}/>}
            </div>
            <small>Posted on <span
                className={styles.postDate}>{Moment(props.itemObj.created_at).format("MMM D, YYYY")}</span></small>
            <div className={styles.content}>
                <SocialMarkdown platform={attribution} text={props.itemObj.description}/>
                {!process.env.MERITOCRACY_CHAT_ENABLED &&
                    organizationStore.schoolFeedEnabledForOrganization &&
                    props.itemObj.meritchat_enabled &&
                    <JoinDiscussionButton itemObj={props.itemObj as IReactiveNewsContentItem}/>}
                {props.itemObj.link && <ReadMoreButton itemObj={props.itemObj}/>}
            </div>
            <div className={styles.attribution}>
                <small>
                    <ClickableLink aria-label={`Link to ${props.itemObj.organization.title}'s News Feed`}
                                   title={`Link to ${props.itemObj.organization.title}'s News Feed`}
                                   href={buildCleverFeedUrl(props.itemObj.organization.id, 'news')}>{`${props.itemObj.organization.title} News`}</ClickableLink></small>
            </div>

        </article>
        {process.env.MERITOCRACY_CHAT_ENABLED && props.itemObj.meritchat_enabled && <div style={{
            clear: "left",
        }}>
            <MeritChatThread
                source_id={props.itemObj.id}
                organization_id={props.itemObj.organization_id}
                source_category={props.itemObj.type}
            />
        </div>}
    </div>
})

export default NewsModalContent;
